export const COMMENT_PREVIEW_MAX_CHARS = 128;
export const DEFAULT_COMMENT_MAX_LENGTH = 100;
